import { View } from "@tarojs/components";
import classNames from "classnames";
import * as React from "react";
import { prefixClassname } from "../styles/index.js";
function PasswordInputFeedback(props) {
    const { className, color, ...restProps } = props;
    return (React.createElement(View, { className: classNames(prefixClassname("password-input__feedback"), {
            [prefixClassname("password-input__feedback--primary")]: color === "primary",
            [prefixClassname("password-input__feedback--info")]: color === "info",
            [prefixClassname("password-input__feedback--success")]: color === "success",
            [prefixClassname("password-input__feedback--warning")]: color === "warning",
            [prefixClassname("password-input__feedback--danger")]: color === "danger",
        }, className), ...restProps }));
}
export default PasswordInputFeedback;
